import { Component, Input } from '@angular/core';

@Component({
  selector: 'inc-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent {
  @Input() classes = 'container';
  constructor() { }
}
